import React from 'react'
import { ToppingInfo } from '../index.styled'

const ToppingInfoButton = React.memo(({
	layout,
	subItem,
	subItemIndex,
	onClickToppingInfo,
}) => {
	return (
		<ToppingInfo
			className={layout + (subItem.quantity < 0 ? ' info' : '')}
			onClick={event => onClickToppingInfo(event, subItemIndex)}
			data-testid="btn-info-topping"
		>
			<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
				<path d="M9 0C4.00909 0 0 4.00909 0 9C0 13.9909 4.00909 18 9 18C13.9909 18 18 13.9909 18 9C18 4.00909 13.9909 0 9 0ZM10.6364 13.0909C10.6364 13.9909 9.9 14.7273 9 14.7273C8.1 14.7273 7.36364 13.9909 7.36364 13.0909V9.40909C7.36364 8.50909 8.1 7.77273 9 7.77273C9.9 7.77273 10.6364 8.50909 10.6364 9.40909V13.0909ZM9 5.72727C8.1 5.72727 7.36364 4.99091 7.36364 4.09091C7.36364 3.19091 8.1 2.45455 9 2.45455C9.9 2.45455 10.6364 3.19091 10.6364 4.09091C10.6364 4.99091 9.9 5.72727 9 5.72727Z" fill="white" />
			</svg>
		</ToppingInfo>
	)
})

export default ToppingInfoButton
ToppingInfoButton.displayName = 'ToppingInfoButton'
